export default __webpack_public_path__ + "static/media/single-2.c7e14268.jpg";